<template>
  <v-card>
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold">
        Merge transfer Details
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <div v-if="transaction.started_at != null">
        <v-btn color="primary" :disabled="transaction.started_at == null" @click="downloadInvoice">
          <v-icon>
            mdi-download
          </v-icon>
          Download receipt
        </v-btn>
      </div>
      <v-spacer v-if="showStartTransferBtn"></v-spacer>

      <v-spacer></v-spacer>
      <v-btn
        v-if="cashinIsStuck"
        class="mr-3"
        color="primary"
        :loading="isRetrying"
        @click="retryDeposit"
        :disabled="isArchived"
      >
        <v-icon color="light-blue lighten-4">mdi-sync</v-icon>
        Retry Merge Transfer
      </v-btn>
      <v-spacer v-if="cashinIsStuck"></v-spacer>

      <v-spacer></v-spacer>
      <v-btn
        v-if="mergeIsStuck"
        class="mr-3"
        color="primary"
        :loading="isRetryingSuspicious"
        @click="retrySuspiciousMerge"
        :disabled="isArchived"
      >
        <v-icon color="light-blue lighten-4">mdi-sync</v-icon>
        Bypass suspicion
      </v-btn>
      <v-spacer v-if="mergeIsStuck"></v-spacer>

      <!-- <v-btn color="primary" :loading="isArchiving" :disabled="isArchived" @click="toggleActivity">
        <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
        Archive payin
      </v-btn> -->
      <!-- <v-btn color="primary ml-3" :loading="isRestoring" v-if="isArchived" @click="restorecashin">
        <v-icon color="light-blue lighten-4">mdi-restore</v-icon>
        Restore
      </v-btn> -->
    </v-toolbar>

    <!-- cashin info -->
    <v-divider />
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" md="2" aria-rowspan="2">
          <h2 class="subtitle-2 text-uppercase">Transfer Details</h2>
        </v-col>
        <v-col cols="12" md="2">
          <key-value
            title="Receiver full name"
            :value="transactionKey('destination_user.full_name')"
            type="date"
          />
        </v-col>
        <v-col cols="12" md="1">
          <key-value title="Amount" :value="transactionKey('amount_without_fee')" type="date">
            €{{ transactionKey("amount_without_fee") | currency }}
          </key-value>
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Local Amount">
            <span class="font-weight-bold primary--text title">
              {{ transactionKey("local_amount_without_fee") | currency
              }}{{ transactionKey("local_currency") }}
            </span>
          </key-value>
        </v-col>
        <v-col cols="12" md="1">
          <key-value title="Fee"> €{{ transactionKey("applied_fee") | currency }} </key-value>
        </v-col>
        <v-col cols="12" md="1">
          <key-value title="Last Run Stage" type="date">
            {{ transaction.last_run_stage }}
          </key-value>
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Started At" :value="transactionKey('started_at')" type="date" />
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Done At" :value="transactionKey('done_at')" type="date" />
        </v-col>
        <v-col cols="12" md="1">
          <key-value title="Status" :value="transactionKey('status')" type="date" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  components: {},
  props: {
    dataTransaction: {
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      transaction: this.dataTransaction,
      completingTransfer: false,
      isArchived: this.dataTransaction.isArchived || false,
      isArchiving: false,
      isRestoring: false,
      isRetrying: false,
      isRetryingSuspicious: false,
    };
  },
  computed: {
    cashinIsStuck() {
      const status = this.transactionKey("status");
      if (status === "started" || status === "error") {
        return true;
      }
      return false;
    },
    mergeIsStuck() {
      const status = this.transactionKey("status");
      if (status === "suspicious") {
        return true;
      }
      return false;
    },
  },
  created() {},

  methods: {
    transactionKey(key, defaultValue = null) {
      return this.extractDataKey(this.transaction, key, defaultValue);
    },
    retryDeposit() {
      this.isRetrying = true;
      this.$http
        .get(`api/v1/transactions/merges/retry/${this.transactionKey("id")}`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({
            name: "merge-transfers.show",
            params: { id: this.transactionKey("id") },
          });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isRetrying = false));
    },
    retrySuspiciousMerge() {
      this.isRetryingSuspicious = true;
      this.$http
        .get(`api/v1/transactions/bypass-suspicion/${this.transactionKey("id")}`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({
            name: "merge-transfers.show",
            params: { id: this.transactionKey("id") },
          });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isRetryingSuspicious = false));
    },
  },
};
</script>
